module.exports = __webpack_public_path__ + "img/ruby.6d90ddca.png";